export default {
  colors: {
    primary_50: "#f4f5fb",
    primary_100: "#e9efff",
    primary_200: "#dce1ff",
    primary_light: "#c5cae9",
    primary_400: "#8f9eff",
    primary_500: "#7485f3",
    primary_700: "#3f51b5",
    primary_vivid: "#536dfe",
    primary: "#3f51b5",
    primary_dark: "#303f9f",
    complementary: "#ffffff",
    complementary_dark: "#e4e4e4",
    complementary_light: "#fcfcfc",
    complementary_50: "#f0f6f4",
    complementary_100: "#FEF8F8",
    complementary_200: "#f5f5f5",
    complementary_250: "#f1f3f4",
    complementary_300: "#e5e5e5",
    complementary_400: "#dddddd",
    complementary_450: "#d6d8d9",
    complementary_500: "#bdbdbd",
    complementary_600: "#9e9e9e",
    complementary_700: "#757575",
    complementary_800: "#444444",
    complementary_900: "#212121",
    black: "#0e0e0e",
    black_800: "#323232",
    yellow: "#ffb900",
    yellow_100: "#fbe9e7",
    yellow_400: "#ffa726",
    yellow_500: "#f9a825",
    red_50: "#f8f1f5",
    red_100: "#ead9e4",
    red_200: "#d8afbc",
    red_400: "#ab4c61",
    red_500: "#dd2c00",
    red_600: "#a90021",
    red_700: "#660014",
    red: "#870002",
    green_100: "#e1eee9",
    green_300: "#9ec9b7",
    green_400: "#19ac8a",
    green: "#0b9b7a",
    green_800: "#188068",
    brown: "#7d5f4f"
  },
  font_sizes: {
    giant: "32px",
    x4_large: "28px",
    x3_large: "24px",
    x2_5_large: "22px",
    x2_large: "20px",
    large: "18px",
    x2_medium: "16px",
    x1_medium: "15px",
    x_medium: "14px",
    medium: "13px",
    x_small: "12px",
    small: "11px",
    little: "8px"
  },
  font_weight: {
    bold: 600,
    medium: 500,
    regular: 400,
    light: 300,
    x_light: 200
  }
};
